import { UserEditWidget } from "Settings/User/Widgets/UserEditWidget";
import { Box, CircularProgress } from "@mui/material";
import { useUser } from "../Api/Query/useUserProfileQuery";

//TODO[ADRIAN]: WTF is this tab??
export const UserDetailTab = () => {
	const { user, isLoading } = useUser();

	if (isLoading) {
		return (
			<Box width="100%" display="flex" justifyContent="center" mt={5}>
				<CircularProgress />
			</Box>
		);
	}

	return user ? <UserEditWidget userId={user.id} user={user} /> : <>NO DATA</>;
};
